import React, { useState, useRef, useEffect } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FiEdit2 } from "react-icons/fi";
import { FiXCircle } from "react-icons/fi";

const Dropdown = ({ getAction, invoiceItemsData, index, className }) => {

    const [showDropdown, setShowDropdown] = useState(false);
    const toggleDropdown = (e) => {
        e.preventDefault()
        setShowDropdown(!showDropdown);
    };

    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleDeleteDrug = (e) => {
        e.preventDefault()
        getAction('delete', invoiceItemsData, index)
        setShowDropdown(false)
    };
    const handleEditDrug = (e) => {
        e.preventDefault()
        getAction('edit', invoiceItemsData, index)
        setShowDropdown(false)
    };

    return (
        <div className={`td_btn dropdown-container ${className}`} >
            <button onClick={toggleDropdown} className="dot-button">
                <BsThreeDotsVertical />
            </button>
            {showDropdown && (
                <div
                    ref={dropdownRef}
                    className="dropdown-content show-dropdown"
                >
                    <button onClick={(e) => handleEditDrug(e)}>
                        <span> <FiEdit2 className="text-green-800" /> </span> Edit details
                    </button>
                    <button onClick={(e) => handleDeleteDrug(e)}>
                        <span>
                            <FiXCircle className="text-red-800" />
                        </span>
                        Delete
                    </button>
                </div>
            )}
        </div>
    );
}

export default Dropdown;